import React from "react";
import { TextField } from "@mui/material";

/**
 * Authenticator code input.
 *
 * The backend accepts 6-8 characters, so we do not hard-clamp to six.
 * `inputMode="numeric"` brings up the numeric keypad on phones, but the type
 * stays text: a number input shows spinners and silently drops leading zeros,
 * and `012345` is a valid code.
 */
const TotpCodeField: React.FC<{
  value: string;
  onChange: (value: string) => void;
  label?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  error?: boolean;
  helperText?: React.ReactNode;
  onEnter?: () => void;
}> = ({
  value,
  onChange,
  label = "Authenticator code",
  autoFocus,
  disabled,
  error,
  helperText,
  onEnter,
}) => (
  <TextField
    label={label}
    value={value}
    onChange={(e) => onChange(e.target.value.replace(/[^\dA-Za-z]/g, "").slice(0, 8))}
    onKeyDown={(e) => {
      if (e.key === "Enter" && onEnter) {
        e.preventDefault();
        onEnter();
      }
    }}
    autoFocus={autoFocus}
    disabled={disabled}
    error={error}
    helperText={helperText}
    fullWidth
    autoComplete="one-time-code"
    slotProps={{
      htmlInput: {
        inputMode: "numeric",
        maxLength: 8,
        style: {
          fontFamily: "monospace",
          fontSize: 22,
          letterSpacing: "0.4em",
          textAlign: "center",
        },
      },
    }}
  />
);

export default TotpCodeField;
